import isEmpty from 'lodash/isEmpty';
import { bool, func, number } from 'prop-types';
import React from 'react';

import DiscardableForm from '../../generic/DiscardableForm';
import FileUploader from '../../generic/FileUploader';
import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';
import { flash } from '../../utils/flash';
import { ORIGINS } from '../constants';

const endpoint = api.addCreative;

const fileMetaFields = [{ id: 'name', name: 'Name', placeholder: 'File name' }];

class AddCreative extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const { onRequest, onSuccess, opportunityId, loading } = this.props;

    if (loading) return; // only make one request at a time

    const selectedFiles = endpoint.uploader.getFiles();
    if (isEmpty(selectedFiles)) return;

    const meta = { opportunityId, origin: ORIGINS[0] };
    onRequest(meta)
      .then(files => {
        onSuccess(files.map(file => file.response.body));
        flash('Creative uploaded successfully');
      })
      .catch(console.error); // eslint-disable-line no-console
  }

  render() {
    return (
      <DiscardableForm onSubmit={this.handleSubmit}>
        <FileUploader
          hideUploadButton
          id="creative-file"
          manager={endpoint.uploader}
          metaFields={fileMetaFields}
          name="file"
          note="Select image or movie files…"
        />
      </DiscardableForm>
    );
  }
}

AddCreative.propTypes = {
  opportunityId: number.isRequired,
  onRequest: func.isRequired,
  onSuccess: func.isRequired,
  loading: bool.isRequired,
};

export default withApiRequest({
  query: endpoint,
})(AddCreative);
